import { createStore, combineReducers } from 'redux';
import { authSlice } from './auth-slice/auth-slice';
import { usermanagementSlice } from './usermanagement-slice/usermanagement-slice';
import { appSlice } from './app-slice/app';
import { mlCreatorSlice } from './mlcreator-slice/mlcreator';
import { mlTesterSlice } from './mltester-slice/mltester';
import { predictionSlice } from './prediction-slice/prediction';
import { optimizationSlice } from './optimization-slice/optimization';

const reducers = {
  app: appSlice.reducer,
  auth: authSlice.reducer,
  usermanagement: usermanagementSlice.reducer,
  mlcreator: mlCreatorSlice.reducer,
  mltester: mlTesterSlice.reducer,
  prediction: predictionSlice.reducer,
  optimization: optimizationSlice.reducer
};

export default function configureStore(initialState: object) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const store: any = createStore(createReducer(null), initialState);

  store.asyncReducers = {};

  store.injectReducer = (key: string, asyncReducers: object) => {
    store.asyncReducers[key] = asyncReducers;
    store.replaceReducer(createReducer(store.asyncReducers));
  };

  return store;
}

function createReducer(asyncReducers: object | null) {
  return combineReducers({
    ...reducers,
    ...asyncReducers,
  });
}
